export interface FieldErrorParserInterface {
  errors?: { property: string; error: string }[];
  property?: string;
  label?: string;
  formIsTouched?: boolean;
  fieldIsTouched?: boolean;
}
export interface FieldErrorParserResultInterface {
  showErrors: boolean;
  visibleErrors: {
    property: string;
    error: string;
  }[];
  firstError: string;
  showFirstError: string;
}

export default function fieldErrorParser(
  data: FieldErrorParserInterface
): FieldErrorParserResultInterface {
  const showErrors = data.fieldIsTouched || data.formIsTouched;
  const visibleErrors = data.errors.filter(err => err.property === data.property);
  const firstError = visibleErrors.length ? visibleErrors[0].error : '';
  const showFirstError = showErrors && firstError;

  return {
    showErrors,
    visibleErrors,
    firstError,
    showFirstError,
  };
}
